module.exports = __webpack_public_path__ + "static/media/ic_msg_warning.6d47d78c.svg";